export default "__VITE_ASSET__WZGNcfIO__"